import React, { Component } from "react";
import myplexAPI from "../../api/myplexAPI";
import Img from "../../utils/similarContentImg";
import { Link } from "react-router-dom";
// import { slugify } from "../../utils/stringSlugify";
import { slugify } from "../../../commonfiles/stringSlugify";
import OwlCarousel from "react-owl-carousel3";
import "react-owl-carousel2/src/owl.carousel.css";
import "react-owl-carousel2/src/owl.theme.default.css";
//import OwlCarousel from "react-owl-carousel2";
// import ParseImgURL from "../../utils/parseImgURL";
// import { getURLName } from "../../utils/urlMenu";
// import { getURLName } from "../../../commonfiles/urlMenu";
import sessionFun from "../../../commonfiles/SessionStorage";
import { isMobile } from "react-device-detect";
// import Slider from "react-slick";

export default class Episodes extends Component {
  tabName = "";
  contentPosition = "";
  carouselPosition = "";
  contentSource = "";
  sourceName = "";

  constructor(props) {
    super(props);
    this.state = {
      seasons: [],
      episodes: [],
      similarEpisode: [],
      limit: 15,
      hasMore: true,
      loadMore: false,
      contentId: this.props.ContentId,
      season_title: "",
      getTrendingTvShows: [],
      seasonnumber: "season1",
      startIndex: 1,
      count: 100,
      isShow: false,
      showDisplayTabs: [],
      tabsList: [],
      mainContentId: null,
      seasonText: null,
      multipleseason: [],
    };
  }
  componetWillMount() {
    if (sessionStorage.getItem(this.state.contentId)) {
      var carosuelDetTab = sessionStorage
        .getItem(this.state.contentId)
        .split("@@");
      if (carosuelDetTab.length > 0) {
        this.carouselPosition = carosuelDetTab[0];
        this.statecontentPosition = carosuelDetTab[1];
        this.tabName = carosuelDetTab[2];
        this.contentSource = carosuelDetTab[3];
        this.sourceName = carosuelDetTab[4];
      }
    }
  }
  componentDidMount() {
    this.getSeasonsTab();
    // this.getsimilarEpisodes();
    // this._getSeasons(this.props.ContentId);

    //this._getTrendingTvshows();
  }
  getSeasonsTab = () => {
    var contentIdDetail = this.props.ContentId;
    if (this.props.seriesId) {
      contentIdDetail = this.props.seriesId;
    }
    myplexAPI
      .getTvshowEpisodes(contentIdDetail, 1, this.state.count, 1)
      .then((response) => {
        // console.log(response);
        if (response.data.results.length > 0) {
          if (
            this._filterEpisodes(response.data.results)[0].generalInfo.type ===
            "tvseason"
          ) {
            this.setState({
              mainContentId: response.data.results[0].generalInfo._id,
              multipleseason: response.data.results,
            });
            this._fetchTabs(response.data.results[0]);
            this.getsimilarEpisodes(response.data.results[0].generalInfo._id);
            //  else {
            //   this.setState({ tabsList: tabsList }, () => {
            //     this.getEpisodes(
            //       response.data.results[0].generalInfo._id,
            //       1,
            //       1000,
            //       -1
            //     );
            //   });
            //   //this. _getSeasons(this.props.ContentId);
            // }
          } else {
            this.setState({
              episodes: this._filterEpisodes(response.data.results),
            });

            this.getsimilarEpisodes(
              this._filterEpisodes(response.data.results)[0].globalServiceId
            );
          }
        }
      });
  };

  getsimilarEpisodes = (Id) => {
    //  var Id = "133725";
    // console.log("ppp",this.props);
    var sno = this.props.info.content.serialNo;
    var statnum = parseInt(sno);
    var lastChar = sno.slice(-1);
    // console.log(lastChar);
    var endnum;

    if (statnum <= 10) {
      statnum = 1;
    } else {
      statnum = Math.floor(sno / 10) + 1;
    }
    if (lastChar > 5) {
      endnum = statnum + 1;
    } else {
      endnum = statnum - 1;
    }
    // console.log(endnum);
    myplexAPI.getTvshowEpisodes(Id, statnum, 10, 1).then((response) => {
      // console.log("sep", response);
      if (response.data.results.length > 0) {
        if (
          this._filterEpisodes(response.data.results)[0].generalInfo.type ===
            "tvseason" ||
          this._filterEpisodes(response.data.results)[0].generalInfo.type ===
            "tvseries"
        ) {
        } else {
          this.setState({
            similarEpisode: this._filterEpisodes(response.data.results),
          });
        }
      }
    });

    if (endnum > 0) {
      let finalepisodeslist;
      myplexAPI.getTvshowEpisodes(Id, endnum, 10, 1).then((response) => {
        // console.log("sep", response);
        if (response.data.results.length > 0) {
          if (
            this._filterEpisodes(response.data.results)[0].generalInfo.type ===
              "tvseason" ||
            this._filterEpisodes(response.data.results)[0].generalInfo.type ===
              "tvseries"
          ) {
          } else {
            if (endnum > 5) {
              finalepisodeslist = [
                ...this.state.similarEpisode,
                ...this._filterEpisodes(response.data.results),
              ];
            } else {
              finalepisodeslist = [
                ...this._filterEpisodes(response.data.results),
                ...this.state.similarEpisode,
              ];
            }
            // console.log(finalepisodeslist);
            this.setState({
              similarEpisode: finalepisodeslist,
            });
          }
        }
      });
    }
  };
  _fetchTabs = (response) => {
    var showDisplayStart, showDisplayEnd, showDisplayfrequency;
    var tabsList = [];
    this.setState({
      mainContentId: response.generalInfo._id,
    });
    if (Object.keys(response.generalInfo.showDisplayTabs).length > 0) {
      this.setState({
        seasonText: response.generalInfo.showDisplayTabs.showDisplayText,
      });

      showDisplayStart =
        response &&
        response.generalInfo &&
        response.generalInfo.showDisplayTabs &&
        response.generalInfo.showDisplayTabs.showDisplayStart;
      showDisplayEnd =
        response &&
        response.generalInfo &&
        response.generalInfo.showDisplayTabs &&
        response.generalInfo.showDisplayTabs.showDisplayEnd;
      showDisplayfrequency =
        response &&
        response.generalInfo &&
        response.generalInfo.showDisplayTabs &&
        response.generalInfo.showDisplayTabs.showDisplayfrequency;

      var totalEps = showDisplayEnd - showDisplayStart;
      var seasonSize = Math.ceil(totalEps / showDisplayfrequency);
      var startnumber = 0;
      var endnumber = 0;
      var recurringnumber = +showDisplayStart;

      for (var i = 0; i < seasonSize; i++) {
        if (i === 0) {
          startnumber = +showDisplayStart + +showDisplayfrequency - 1;
          endnumber = showDisplayStart;
        } else {
          recurringnumber = +recurringnumber + +showDisplayfrequency;
          startnumber = recurringnumber - 1 + +showDisplayfrequency;
          endnumber = +recurringnumber;
          if (startnumber > showDisplayEnd) {
            startnumber = +showDisplayEnd;
          }
        }

        let items = [
          showDisplayEnd - showDisplayfrequency,
          showDisplayEnd,
          showDisplayfrequency,
          endnumber + "-" + startnumber,
          i + 1,
        ];
        tabsList = [...tabsList, items];
      }

      // console.log("tabsList", tabsList);
      if (tabsList.length > 0) {
        this.setState({ tabsList: tabsList }, () => {
          this.getEpisodes(
            response.generalInfo._id,
            tabsList.length,
            tabsList[0][2],
            1
          );
        });
      } else {
        this.setState({ tabsList: tabsList }, () => {
          this.getEpisodes(response.generalInfo._id, 1, 1000, -1);
        });
      }
    } else {
      this.getEpisodes(response.generalInfo._id, 1, 1000, -1);
    }
  };
  getEpisodes = (Id, startIndex, count, orderBy, flag = 0) => {
    myplexAPI
      .getTvshowEpisodes(Id, startIndex, count, orderBy)
      .then((response) => {
        // console.log(response);
        if (response.data.results && response.data.results.length > 0) {
          this.setState(
            {
              episodes:
                this.state.tabsList.length > 0
                  ? this._filterEpisodes([...response.data.results].reverse())
                  : this._filterEpisodes(response.data.results),
            },
            () => {
              this.props.callBackTvShow([this.state.episodes[0]]);
            }
          );
        }
      });
  };

  onLoadMore = () => {
    this.setState({
      limit: this.state.limit + 12,
    });
    if (this.state.episodes.length <= this.state.limit + 12) {
      this.setState({
        loadMore: false,
      });
    }
  };
  _filterEpisodes = (data) => {
    return data.filter((d) => d.globalServiceId !== d._id);
  };

  // _getSeasons = (Id) => {
  //   myplexAPI
  //     .getTvshowEpisodes(Id, this.state.startIndex, this.state.count)
  //     .then((response) => {
  //       if (response.data.results.length > 0) {
  //         const type = response.data.results[0].generalInfo.type;
  //         if (type === "tvseason") {
  //           if (
  //             this.props.episodesParams.PageName === "tvshows" &&
  //             response.data.results.length > 0
  //           ) {
  //             this.setState({
  //               isShow: true,
  //             });
  //           } else {
  //             this.setState({
  //               isShow: false,
  //             });
  //           }
  //         }
  //         this._filterEpisodes(response.data.results)[0].generalInfo.type ===
  //         "tvseason"
  //           ? this.setState(
  //               {
  //                 seasons: this._filterEpisodes(response.data.results),
  //                 seasonnumber:
  //                   "season" + response.data.results[0].content.siblingOrder,
  //               },
  //               () => {
  //                 this._getEpisodes(response.data.results[0]._id);
  //               }
  //             )
  //           : this.setState(
  //               {
  //                 episodes: this._filterEpisodes(response.data.results),
  //               },
  //               () =>
  //                 !this.props.tvepisode &&
  //                 this.props.setVideoID(this.state.episodes[0]._id)
  //             );
  //       }
  //     });
  // };
  _getEpisodes = (Id, flag = 0) => {
    myplexAPI
      .getTvshowEpisodes(Id, this.state.startIndex, this.state.count)
      .then((response) => {
        if (response.data.results.length > 0) {
          this.setState(
            {
              episodes: this._filterEpisodes(response.data.results),
            },
            () => {
              if (!this.props.tvepisode && flag === 0) {
                this.props.callBackTvShow([this.state.episodes[0]]);
              }
            }
          );
        }
      });
    this.setState({
      contentId: Id,
    });
    this.setState({
      startIndex: 1,
    });
  };

  Episodes = () => {
    if (
      (this.state.tabsList.length > 0 || this.state.seasons.length > 0) &&
      isMobile
    ) {
      return this.state.episodes.map((episode, i) => {
        // sessionFun(
        //   this.carouselPosition,
        //   this.contentPosition,
        //   this.tabName,
        //   this.contentSource,
        //   this.sourceName,
        //   episode.generalInfo._id
        // );
        var beautifytitle =
          episode.generalInfo.title && episode.generalInfo.title.split("|");
        var t = beautifytitle[0];
        if (beautifytitle[1]) {
          t = t + beautifytitle[1];
        }
        var url = {
          pathname: `/${this.props.episodesParams.PageName}/detail/${
            episode.generalInfo._id
          }/${slugify(episode.globalServiceName)}/${slugify(t)}`,
        };
        return (
          episode.globalServiceId !== episode._id && (
            <div className="epi_list" key={i}>
              <Link to={url} key={i}> 
                <div className="epi_img_part" onClick={() => this.sourceDetails("Episodes",i,episode.generalInfo._id)}>
                  <Img caroselimg={episode} key={i} />
                  {/* <div className="progress">
                    <div className="bar" style={{ width: 35 }}></div>
                  </div> */}
                </div>
                <div className="epi_details_part">
                  <h3>{episode.title}</h3>
                  <ul>
                    {/* <li>Episodes</li>
                    <li>|</li> */}
                    <li>
                      {episode.content.duration.replace(/^0:(?:0:0?)?/, "")}{" "}
                      mins
                    </li>
                  </ul>
                </div>
              </Link>
            </div>
          )
        );
      });
    } else {
      return this.state.episodes.map((episode, i) => {
        var beautifytitle =
          episode.generalInfo.title && episode.generalInfo.title.split("|");
        var t = beautifytitle[0];
        if (beautifytitle[1]) {
          t = t + beautifytitle[1];
        }
        var url = {
          pathname: `/${this.props.episodesParams.PageName}/detail/${
            episode.generalInfo._id
          }/${slugify(episode.globalServiceName)}/${slugify(t)}`,
        };
        return (
          episode.globalServiceId !== episode._id && (
            <div id={episode._id} key={i}>
              <Link to={url} key={i}>
                <div onClick={() => this.sourceDetails("Episodes",i,episode.generalInfo._id)}>
                  <Img caroselimg={episode} key={i} />
                </div>
                <div className="episodes-info">
                  <span>{episode.title}</span>
                </div>
                <span className="episodes_info__time">
                  {episode.content.duration.replace(/^0:(?:0:0?)?/, "")} mins
                </span>
              </Link>
            </div>
          )
        );
      });
      // );
    }
  };
  similarEpisodes = () => {
    if (this.state.similarEpisode.length > 0) {
      return this.state.similarEpisode.map((episode, i) => {
        var beautifytitle =
          episode.generalInfo.title && episode.generalInfo.title.split("|");
        var t = beautifytitle[0];
        if (beautifytitle[1]) {
          t = t + beautifytitle[1];
        }
        var url = {
          pathname: `/${this.props.episodesParams.PageName}/detail/${
            episode.generalInfo._id
          }/${slugify(episode.globalServiceName)}/${slugify(t)}`,
        };
        return (
          episode.globalServiceId !== episode._id && (
            <div id={episode._id} key={i}>
              <Link to={url} key={i}>
                <div onClick={() => this.sourceDetails("Episodes",i,episode.generalInfo._id)}>
                  <Img
                    caroselimg={episode}
                    key={i}
                    caroselname={"episodeGrid"}
                  />
                </div>
                <div className="episodes-info">
                  <span>{episode.title}</span>
                </div>
                {/* <span className="episodes_info__time">
                 {episode.content.duration.replace(/^0:(?:0:0?)?/, '')} mins
                </span> */}
              </Link>
            </div>
          )
        );
      });
    }
  };
  Seasons = () =>
    this.state.multipleseason.map((season, i) => {
      return (
        <option
          value={season._id}
          key={season._id}
          data-season={JSON.stringify(season)}
        >
          Season {season.content.siblingOrder}
        </option>
      );
    });

  getSeasonsView = () => {
    if (this.state.tabsList.length > 0) {
      // console.log('mytablList',this.state.tabsList)
      return this.state.tabsList
        .slice()
        .reverse()
        .map((season, i) => {
          if (i === 0) {
            return (
              <li
                className="tab_item tab_active "
                onClick={(e) => {
                  this.getEpisodes(
                    this.state.mainContentId,
                    season[4],
                    season[2],
                    1
                  );
                  this.activeTab(e);
                }}
                key={i}
              >
                <h3>
                  {/* {this.state.seasonText !== "" && this.state.seasonText
                  ? this.state.seasonText
                  : "Episodese"}{" "}
                {season[3]} */}
                  Latest Episodes
                </h3>
              </li>
            );
          } else {
            return (
              <li
                className={`tab_item `}
                onClick={(e) => {
                  this.getEpisodes(
                    this.state.mainContentId,
                    season[4],
                    season[2],
                    1
                  );
                  this.activeTab(e);
                }}
                key={i}
              >
                <h3>
                  {this.state.seasonText !== "" && this.state.seasonText
                    ? this.state.seasonText + " "
                    : "Episodese "}
                  {season[3]}
                </h3>
              </li>
            );
          }
        });
    }
  };
  setSelectedOption = (val) =>{
    var id,s,c,o;
    if(val){

      const myArray = val.split('|');
      id = myArray[0] && myArray[0];
      s  = myArray[1] && myArray[1];
      c  = myArray[2]  && myArray[2];
      o  = myArray[3] && myArray[3];
    }
    // console.log(id, s, c ,o); 
    this.getEpisodes(id, s, c ,o);
  }
  getSeasonsViewMobile = () => {
    if (this.state.tabsList.length > 0) {
      // console.log('mytablList',this.state.tabsList)
      return this.state.tabsList
        .slice()
        .reverse()
        .map((season, k) => {
         
          if( k==0 ) {
            return (
            <option value={
              this.state.mainContentId+"|"+season[4]+"|"+season[2]+"|"+1}>Latest Episodes </option>
            );
          }else {
            return (
              <option value={
                this.state.mainContentId+"|"+season[4]+"|"+season[2]+"|"+1}> {  this.state.seasonText !== "" && this.state.seasonText
              ? this.state.seasonText + " "
              : "Episodese "}
            {season[3]}</option>
            
            );
          }
          
          });
  } }

  Carosulview = () => {
    return this.state.seasons.map((season, i) => {
      if (i === 0) {
        return (
          <li
            className="tab_item tab_active "
            onClick={(e) => {
              this._getEpisodes(season._id);
              this.activeTab(e);
            }}
          >
            <h3>
              {this.props.season_title} {season.content.siblingOrder}
            </h3>
          </li>
        );
      } else {
        return (
          <li
            className="tab_item  "
            onClick={(e) => {
              this._getEpisodes(season._id);
              this.activeTab(e);
            }}
          >
            <h3>
              {this.props.season_title} {season.content.siblingOrder}
            </h3>
          </li>
        );
      }
    });
  };

  sourceDetails = (source_details,i,id) => {
    setTimeout(function () {
    // localStorage.setItem("source details", source_details);
    localStorage.setItem("source", "carousel");
    localStorage.setItem("trackingId", "");
      sessionFun(
         0,
         i+1,
          "programs",
          "programs",
          "programs",
          id
        );

  }, 5000);};
  //active tab
  activeTab = (e) => {
    var elements = e.currentTarget
      .closest(".owl-carousel")
      .getElementsByTagName("li");
    //console.log(elements,'elementsssss')
    for (var i = 0; i < elements.length; i++) {
      elements[i].classList.remove("tab_active");
    }
    e.currentTarget.classList.add("tab_active");
  };
  changeSeasonsHandler = (e) => {
    var data = e.target.options[e.target.selectedIndex].dataset.season;

    data = JSON.parse(data);
    this._fetchTabs(data);
  };
 
  render() {
   
    let perpage = 0;
    // if (this.props.layoutType === "horizontalListBigItem") {
    //   perpage = 10;
    // } else {
    // perpage = 7;
    // }

    const options = {
      items: perpage,

      responsive: {
        320: {
          items: perpage === 10 ? 3 : 2,
          nav: true,
        },
        340: {
          items: perpage === 10 ? 4 : 2,
          nav: false,
        },
        768: {
          items: perpage === 10 ? 5 : 4,
          nav: false,
        },
        1200: {
          items: perpage === 10 ? 6 : 5,
          nav: true,
        },
        1300: {
          items: perpage === 10 ? 7 : 6,
          nav: true,
        },
        1400: {
          items: perpage === 10 ? 8 : 6,
          nav: true,
        },
        1500: {
          items: perpage === 10 ? 8 : 6,
          nav: true,
        },
        1600: {
          items: perpage === 10 ? 9 : 7,
          nav: true,
        },
        1700: {
          items: perpage === 10 ? 10 : 8,
          nav: true,
        },
      },
      nav: true,
      navText: [
        "<div class='carousel-nav-btn carousel-prev-slide'></div>",
        "<div class='carousel-nav-btn carousel-next-slide'></div>",
      ],

      rewind: false,
      margin: 10,
      dots: false,
      autoplay: false,
      loop: false,
    };

    const seasionOptions = {
      responsive: {
        320: {
          items: perpage === 10 ? 3 : 3,
          nav: true,
        },
        340: {
          items: perpage === 10 ? 4 : 3,
          nav: true,
        },
        480: {
          items: perpage === 10 ? 4 : 3,
          nav: true,
        },
        768: {
          items: perpage === 10 ? 5 : 4,
          nav: true,
        },
        1200: {
          items: perpage === 10 ? 6 : 5,
        },
        1300: {
          items: perpage === 10 ? 7 : 7,
        },
        1400: {
          items: perpage === 10 ? 8 : 7,
        },
        1500: {
          items: perpage === 10 ? 8 : 7,
        },
        1600: {
          items: perpage === 10 ? 9 : 7,
        },
        1700: {
          items: perpage === 10 ? 10 : 8,
        },
      },

      nav: true,
      navText: [
        "<div class='carousel-nav-btn carousel-prev-slide'></div>",
        "<div class='carousel-nav-btn carousel-next-slide'></div>",
      ],
      rewind: false,
      margin: 10,
      dots: false,
      autoplay: false,
      loop: false,
      items: 7,
    };

    const events = {
      onDragged: function (event) {},
      onChanged: function (event) {},
    };


    return (
      <div className="mobile_episodes_section episodes_section">
        <section>
          {this.state.multipleseason.length > 1 && (
            <div className="select_options">
              <select
                name="episodes_selection"
                onChange={(e) => this.changeSeasonsHandler(e)}
              >
                {this.Seasons()}
              </select>
            </div>
          )}
          <div className="you-may-like_section">
            <div className="carousel_body">
            <div className="count-episodes">
              {this.state.episodes.length > 0 &&
                this.state.tabsList.length === 0 && (
                  <div> {this.props.episodes_title}</div>
                )}
            </div>

            {this.state.tabsList.length === 0 &&
              this.state.episodes.length > 0 && (
                 <OwlCarousel
                className="owl-theme"
                items={perpage}
                responsive={options.responsive}
                nav={true}
                navText={[
                  "<div class='carousel-nav-btn carousel-prev-slide'></div>",
                  "<div class='carousel-nav-btn carousel-next-slide'></div>",
                ]}
                rewind={false}
                margin={10}
                dots={false}
                autoplay={false}
                slideBy={10}
                loop={false}
                touchDrag={true}
                mouseDrag={true}
              >
                  {this.Episodes()}
                </OwlCarousel>
              )}
            {this.state.similarEpisode.length > 0 &&
              window.location.search == "?continuewatch=true" && (
                <div className="mobile_episodes_carousel continuewatch_carousel">
                  <div className="carousel_body">
                    <div className="home_carosel_title">
                      <h1>Episodes</h1>
                    </div>
                    <div className="episodes_tabs">
                      {this.state.similarEpisode.length && (
                        <div className="carousel_body">
                          <OwlCarousel
                            ref="car"
                            items={perpage}
                           responsive={options.responsive}
                           rewind={false}
                           margin={10}
                           dots={false}
                            events={events}
                            navText={[
                              "<div class='carousel-nav-btn carousel-prev-slide'></div>",
                              "<div class='carousel-nav-btn carousel-next-slide'></div>",
                            ]}
                          >
                            {this.similarEpisodes()}
                          </OwlCarousel>
                        </div>
                        // {/* )
                      )}
                    </div>
                  </div>
                </div>
              )}

            {this.state.tabsList.length > 0 && (
              <div className="mobile_episodes_carousel">
                <div className="carousel_body">
                  <div className="episodes_tabs">
                    {!isMobile ? (
                      <ul className="nav tabs">
                       <OwlCarousel
                      
                              className="owl-theme"
                              items={perpage}
                              responsive={seasionOptions.responsive}
                              nav={true}
                              navText={[
                                "<div class='carousel-nav-btn carousel-prev-slide'></div>",
                                "<div class='carousel-nav-btn carousel-next-slide'></div>",
                              ]}
                              rewind={false}
                              margin={10}
                              dots={false}
                              autoplay={false}
                              slideBy={10}
                              loop={false}
                              touchDrag={true}
                              mouseDrag={true}
                            > 
                          {this.getSeasonsView()}
                          
                        </OwlCarousel> 
                      </ul>
                    ) : (
                      <div className="select_episodes">
                        <select name="episodes"  onChange={e => this.setSelectedOption(e.target.value)}>
                          {/* <option value="Latest Episodes">
                            Latest Episodes
                          </option> */}

                          {this.getSeasonsViewMobile()}
                        </select>
                      </div>
                    )}

                    {isMobile ? (
                      <div className="tab_content">{this.Episodes()}</div>
                    ) : (
                      this.state.episodes.length > 0 && (
                        <div className="carousel_body">
                          <OwlCarousel
                              className="owl-theme"
                              items={perpage}
                              responsive={options.responsive}
                              nav={true}
                              navText={[
                                "<div class='carousel-nav-btn carousel-prev-slide'></div>",
                                "<div class='carousel-nav-btn carousel-next-slide'></div>",
                              ]}
                              rewind={false}
                              margin={10}
                              dots={false}
                              autoplay={false}
                              slideBy={10}
                              loop={false}
                              touchDrag={true}
                              mouseDrag={true}
                            >
                            {this.Episodes()}
                          </OwlCarousel>

                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            )}
            {/* {this.state.seasons.length > 0 && (
              <div className="episodes_tabs">
                <ul className="nav tabs">
                  <OwlCarousel ref="car" options={options} events={events}>
                    {this.Carosulview()}
                  </OwlCarousel>
                </ul>
                {isMobile ? (
                  <div className="tab_content">{this.Episodes()}</div>
                ) : (
                  this.state.episodes.length && (
                    <div class="carousel_body">
                      <OwlCarousel ref="car" options={options} events={events}>
                        {this.Episodes()}
                      </OwlCarousel>
                    </div>
                  )
                )}
              </div>
            )} */}
          </div>
          </div>
        </section>
      </div>
    );
  }
}
